module.exports = __webpack_public_path__ + "static/media/icon-reviewloop-grey.e8c37af3.svg";